import type { AssessmentResultStore } from './interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

export const createInitialState = (): AssessmentResultStore => ({
  activeId: null,
  status: 'idle',
  requestId: 0,
  id: null,
  questions: [],
  comprehension: false,
  assessmentUrls: {
    math: null,
    ela: null,
  },
  score: 0,
  variant: Discipline.Math,
})
